import React, { useEffect, useState } from "react";
import { BACKEND_URL, makeRequestAuth } from "../../_config/api";
import { showErrorToast, showSuccessToast } from "../../utils/toastUtils";
import NoData from "../../utils/DataNotFound";
import { useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import axios from "axios";

export default function AgentSettlements() {
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState("pending"); 
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);

    // Modal States (Isme settleAmount add ho gaya hai)
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [selectedAgentId, setSelectedAgentId] = useState(null);
    const [settleAmount, setSettleAmount] = useState(""); 
    const [maxAmount, setMaxAmount] = useState(0); 

    const fetchPendingAgents = async () => {
        try {
            setLoading(true);
            const res = await makeRequestAuth("post", "/admin/getSerciveJobsList", { pageNo: 1, size: 500, status: "approved" });
            if (!res?.error) {
                const agentsWithCash = res?.data?.list?.filter(agent => agent.cashInHand > 0) || [];
                setData(agentsWithCash);
            }
        } catch (error) {
            showErrorToast("Error fetching agents");
        } finally {
            setLoading(false);
        }
    };

    const fetchHistory = async () => {
        try {
            setLoading(true);
            const { token } = JSON.parse(sessionStorage.getItem("user")) || {};
            const res = await axios.get(`${BACKEND_URL}/admin/getCODSettlements`, { headers: { Authorization: `Bearer ${token}` } });
            if (res.data.status === 1) setData(res.data.data);
        } catch (error) {
            showErrorToast("Error fetching history");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (activeTab === "pending") fetchPendingAgents();
        else fetchHistory();
    }, [activeTab]);

    const handleSettleCOD = async () => {
        if (!selectedAgentId || !settleAmount || settleAmount <= 0) {
            return showErrorToast("Please enter a valid amount!");
        }

        const { token } = JSON.parse(sessionStorage.getItem("user")) || {};
        try {
            const response = await axios.post(`${BACKEND_URL}/admin/clearAgentCOD`, {
                agentId: selectedAgentId,
                amount: Number(settleAmount) // 👈 Yahan se admin ka dala hua amount jayega
            }, { headers: { Authorization: `Bearer ${token}` } });
            
            if (response.data.status === 1) {
                showSuccessToast(`₹${settleAmount} settled successfully!`);
                setShowConfirmModal(false);
                setSelectedAgentId(null);
                setSettleAmount("");
                fetchPendingAgents(); 
            } else {
                showErrorToast(response.data.message);
            }
        } catch (error) {
            showErrorToast(error?.response?.data?.message || "Server Error");
        }
    };

    return (
        <div className="p-6 min-h-screen bg-gray-50">
            <ToastContainer />
            <div className="flex justify-between items-center mb-6">
                <h2 className="text-2xl font-bold text-gray-800">COD Settlements</h2>
                <button onClick={() => navigate(-1)} className="px-4 py-2 rounded-xl border border-[#24ADD7] text-[#24ADD7] hover:bg-[#24ADD7] hover:text-white transition">← Back</button>
            </div>

            <div className="flex gap-4 mb-6 border-b border-gray-200">
                <button onClick={() => setActiveTab("pending")} className={`py-2 px-4 font-semibold ${activeTab === "pending" ? "text-[#24ADD7] border-b-2 border-[#24ADD7]" : "text-gray-500"}`}>Pending Settlements</button>
                <button onClick={() => setActiveTab("history")} className={`py-2 px-4 font-semibold ${activeTab === "history" ? "text-[#24ADD7] border-b-2 border-[#24ADD7]" : "text-gray-500"}`}>Settlement History</button>
            </div>

            <div className="overflow-x-auto bg-white rounded-2xl shadow-sm border border-gray-100">
                <table className="w-full text-left text-sm">
                    <thead className="bg-[#24ADD7] text-white">
                        <tr>
                            <th className="p-4">#</th>
                            {activeTab === "pending" ? (
                                <><th className="p-4">Agent Name</th><th className="p-4">Phone</th><th className="p-4 font-bold">Pending Cash (COD)</th><th className="p-4 text-center">Action</th></>
                            ) : (
                                <><th className="p-4">Date & Time</th><th className="p-4">Agent Name</th><th className="p-4">Cleared By (Admin)</th><th className="p-4 font-bold">Amount Cleared</th></>
                            )}
                        </tr>
                    </thead>
                    <tbody>
                        {loading ? <tr><td colSpan="5" className="p-10 text-center">Loading...</td></tr> : data.length === 0 ? <tr><td colSpan="5" className="p-10"><NoData /></td></tr> : data.map((item, index) => (
                            <tr key={index} className="border-b border-gray-50 hover:bg-gray-50">
                                <td className="p-4">{index + 1}</td>
                                {activeTab === "pending" ? (
                                    <>
                                        <td className="p-4 font-semibold">{item.name}</td><td className="p-4">{item.phone}</td><td className="p-4 font-bold text-orange-500">₹{item.cashInHand}</td>
                                        <td className="p-4 text-center">
                                            <button onClick={() => { 
                                                setSelectedAgentId(item._id); 
                                                setMaxAmount(item.cashInHand);
                                                setSettleAmount(item.cashInHand); // Default pura amount fill karke dikhao
                                                setShowConfirmModal(true); 
                                            }} className="bg-green-500 text-white px-4 py-2 rounded-lg font-semibold hover:bg-green-600 shadow-sm">Settle Cash</button>
                                        </td>
                                    </>
                                ) : (
                                    <>
                                        <td className="p-4 text-gray-600">{new Date(item.date).toLocaleString()}</td><td className="p-4 font-semibold">{item.agentId?.name || "Unknown Agent"}</td><td className="p-4">{item.clearedByAdmin?.userName || "Admin"}</td><td className="p-4 font-bold text-green-600">₹{item.amountCleared}</td>
                                    </>
                                )}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {/* Custom Confirm Modal jisme Input Box laga diya hai */}
            {showConfirmModal && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
                    <div className="bg-white p-6 rounded-2xl shadow-xl w-96 text-center">
                        <h3 className="text-xl font-bold text-gray-800 mb-2">Settle Cash</h3>
                        <p className="text-gray-500 mb-4 text-sm">Agent ka total pending: <span className="font-bold text-orange-500">₹{maxAmount}</span></p>
                        
                        <div className="mb-6 text-left">
                            <label className="text-sm font-bold text-gray-700 block mb-2">Kitna amount settle karna hai?</label>
                            <input 
                                type="number" 
                                value={settleAmount}
                                onChange={(e) => setSettleAmount(e.target.value)}
                                className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:border-[#24ADD7]"
                            />
                        </div>

                        <div className="flex justify-center gap-4">
                            <button onClick={() => setShowConfirmModal(false)} className="px-4 py-2 bg-gray-200 text-gray-800 rounded-lg font-semibold hover:bg-gray-300">Cancel</button>
                            <button onClick={handleSettleCOD} className="px-4 py-2 bg-green-500 text-white rounded-lg font-semibold hover:bg-green-600 shadow-sm">Confirm Settlement</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
